<template>
  <div class="flex justify-content-center align-items-center w-full h-full">
    <Panel class="panel-class text-center md:p-5 w-full ">
      <div class="Paragraph-Medium mb-2">Setup two-factor authentication</div>
      <p class="Caption block mb-4">
        Use Google Authenticator or similar app to scan the QR code
      </p>

      <div class="card flex justify-center justify-content-center">
        <Image 
          :src="qrCodeUrl" 
          alt="QR Code" 
          width="250"
          preview 
          v-if="qrCodeUrl"
        />
        <Skeleton size="5rem" v-else></Skeleton>
      </div>

      <div class="flex justify-content-center mt-5">
        <Button label="Continue" class="teal-700-button" @click="verifyTwoFactor" :disabled="!qrCodeUrl"/>
      </div>
    </Panel>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useAuthStore } from "@/stores/authStore";
import * as authApi from "@/api/auth";
import { Button, Image, Panel, Skeleton } from "primevue";

const authStore = useAuthStore();
const qrCodeUrl = ref(null);

// ✅ reusable function
const generateSecretKey = async () => {
  try {
    const payload = {
      userId: authStore.user?.userId,
      role: authStore.user?.role,
    };

    const res = await authApi.setupAuthenticator(payload);
    qrCodeUrl.value = res.data.data.qrCode;
  } catch (err) {
    console.error("Failed to generate secret:", err.response?.data || err.message);
  }
};

const verifyTwoFactor = async () => {
  try {
    authStore.user.otpConfigured = true;
  } catch (err) {
    console.error("OTP verification failed:", err.response?.data || err.message);
  }
};
onMounted(() => {
  generateSecretKey();
});
</script>
<style scoped>
.panel-class {
    border: none;
    box-shadow: none;
}
</style>